import { Injectable } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";

@Injectable()
export class AddressFormBuilder {
  constructor(private fb: FormBuilder) {}

  private addressLine1 = "";
  private addressLine2 = "";
  private city = "";
  private postCode = "";

  withAddressLine1(addressLine: string) {
    this.addressLine1 = addressLine;
    return this;
  }

  withAddressLine2(addressLine: string) {
    this.addressLine2 = addressLine;
    return this;
  }

  withCity(city: string) {
    this.city = city;
    return this;
  }

  withPostCode(postCode: string) {
    this.postCode = postCode;
    return this;
  }

  create() {
    return this.fb.group({
      addressLine1: [
        this.addressLine1,
        {
          validators: [Validators.required],
          updateOn: "blur",
        },
      ],
      addressLine2: [
        this.addressLine2,
        {
          updateOn: "blur",
        },
      ],
      city: [
        this.city,
        {
          validators: [Validators.required],
          updateOn: "blur",
        },
      ],
      postCode: [
        this.postCode,
        {
          validators: [Validators.required, Validators.minLength(6)],
          updateOn: "blur",
        },
      ],
    });
  }
}
